var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"p-subscribe-to-sms",class:[
    'l-flex',
    'l-flex--column'
  ]},[_c('klaviyo-embed-form',{staticClass:"c-capture-form",attrs:{"embed-code":_vm.embedCode}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }